module.exports = __webpack_public_path__ + "static/media/arrow-right.3bf6e099.svg";